import React from 'react';
import ClassNames from 'classnames';
import idgen from 'app/lib/idgen';
import constants from 'modules/app/constants/materialize';

import Input from './Input';
import Select from './Select';

import 'stylesheets/components/freeTextSelect.scss';

class FreeTextSelect extends React.Component {

    renderOptions() {
        let items = [],
            options = this.props.options;

        for (let i = 0; i < options.length; i++) {
            let opt = options[i];
            items.push(<option key={opt} value={opt}>{opt}</option>);
        }

        return items;
    }


    renderSelect() {
        let {s, m, l, label, className, ...rest} = this.props;

        return (
            //<button className="">
            //    <i className="material-icons">access_time</i>
                <Select type="select" {...rest} />
            //</button>
        );
    }

    render() {
        let {className, ...rest} = this.props;

        return (
            <Input
                suffix={this.renderSelect()}
                wrapperClass={ClassNames('free-text-select', className)}
                {...rest}
                />
        );
        //return (<Input
        //    type="select"
        //    suffix={this.renderSelect()}
        //    {...this.props}>
        //    {this.renderOptions()}
        //</Input>);
    }

}

FreeTextSelect.propTypes = {
    options: React.PropTypes.array.isRequired,
    s: React.PropTypes.number,
    m: React.PropTypes.number,
    l: React.PropTypes.number,
    className: React.PropTypes.string,
    label: React.PropTypes.node
};

export default FreeTextSelect;
